import styled from "styled-components";
import { DialogTextBox } from "../../../modal-dialog/boxes/text/dialog-text.box";

export const PaymentRedirectFocusTitleDefaultBox = styled(DialogTextBox)`
    padding-bottom: 4rem;
`;
